import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Filter } from "../../models/filter.model";
import { Organisation } from "../../models/organisation.model";
import { User } from "../../models/user.model";
import { OrganisationUserDataProvider } from "../../data-provider/organisation-user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { OrganisationMapUserDataProvider } from "../../data-provider/organisation-map-user.dp";
import { PermissionCheck } from "../../shared/permission";

let OrganisationUserMapComponent = {
    selector: "vcOrganisationUserMap",
    templateUrl:
        "/angular/components/organisation-user-map/organisation-user-map.component.html",
    bindings: {
        filter: "=?",
    },
    controller: class OrganisationUserMapController {
        // * bindings for typescript compiler *
        public filter?: Filter;
        // ************************************

        private selectedUser: User;
        private activeOrganisation: Organisation;

        private dialog: DialogUtils;
        private toast: ToastUtils;

        private organisationMapUserDataProvider: OrganisationMapUserDataProvider;
        private organisationUserDataProvider: OrganisationUserDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            OrganisationMapUserDataProvider: OrganisationMapUserDataProvider,
            OrganisationUserDataProvider: OrganisationUserDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ModelsUtils: any,
            PermissionCheck: PermissionCheck
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.organisationMapUserDataProvider =
                OrganisationMapUserDataProvider;
            this.organisationUserDataProvider = OrganisationUserDataProvider;
            this.permissionProvider = PermissionCheck;

            this.selectedUser = ModelsUtils.user({});

            CampaignDataProvider.getOrganisations().then(
                (organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                }
            );
        }

        deleteUser(user: User, ev: any): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    locals: {
                        title: "Delete User?",
                        bodyText:
                            "They will be permanently deleted from all associated campaigns",
                    },
                })
                .then(() => {
                    user.oid = this.activeOrganisation.oid;
                    this.organisationUserDataProvider
                        .deleteUser(user)
                        .then(() => {
                            this.toast.success("User removed");
                            this.organisationMapUserDataProvider.reset();
                            this.organisationMapUserDataProvider.getMapMarkers();
                            this.organisationUserDataProvider.getAllUsers(
                                this.filter
                            );
                            this.selectedUser.uid = null;
                        });
                });
        }
    },
};

angular
    .module("organisationUserMap", [])
    .component(
        OrganisationUserMapComponent.selector,
        OrganisationUserMapComponent
    );
